import { NgClass } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [
    MatIcon,
    MatBadge,
    NgClass,
  ],
  standalone: true,
})
export class ButtonComponent {
  readonly buttonTextSize = input<'body-s' | 'body-m' | 'body-l'>('body-m');
  readonly size = input<'small' | 'medium' | 'large'>('medium');
  readonly width = input<'full' | ''>('');
  readonly disabled = input<boolean>(false);
  readonly iconPosition = input<'left' | 'right'>('right');
  @Input() icon: string = '';
  @Input() svgIcon: string = '';
  @Input() text: string = '';
  readonly type = input<'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'primary-white' | 'tertiary-black'>('primary');
  @Input() notification: number | null = null;
  readonly isSubmit = input<boolean>(true);
  readonly buttonClass = input<string>('');
}
